import {
  Divider,
  GKEditor,
  Grid2,
  Show,
  Tab,
  Tabs,
  Typography,
} from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";

const PoliciesForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const [tab, setTab] = useState(0);

  return (
    <Grid2 container spacing={3} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(neutral-900)">
          Policies
        </Typography>
      </Grid2>

      <Grid2 size={12}>
        <Tabs
          sx={{
            "& .MuiTabs-flexContainer": { bgcolor: "var(--white)" },
          }}
          value={tab}
          onChange={(e, val) => setTab(val)}
        >
          <Tab label={"Pricing Policy"} disableRipple />
          <Tab label={"Refund Policy"} disableRipple />
        </Tabs>
        <Divider />
      </Grid2>

      <Grid2
        size={12}
        sx={{
          "& .ck.ck-content.ck-editor__editable": {
            maxHeight: "540px",
            overflow: "auto",
          },
        }}
      >
        <Show.When isTrue={tab === 0}>
          <Controller
            name="compliance.policies.pricingPolicy"
            control={form.control}
            render={({ field, fieldState: { error } }) => (
              <GKEditor
                {...field}
                error={!!error}
                helperText={error?.message}
                toolbar={[
                  "undo",
                  "redo",
                  "|",
                  "heading",
                  "bold",
                  "italic",
                  "underline",
                  "strikethrough",
                  "blockQuote",
                  "|",
                  "fontSize",
                  "fontColor",
                  "fontBackgroundColor",
                  "|",
                  "alignment",
                  "subscript",
                  "superscript",
                  "|",
                  "bulletedList",
                  "numberedList",
                ]}
              />
            )}
          />
        </Show.When>
        <Show.When isTrue={tab === 1}>
          <Controller
            name="compliance.policies.refundPolicy"
            control={form.control}
            render={({ field, fieldState: { error } }) => (
              <GKEditor
                {...field}
                error={!!error}
                helperText={error?.message}
                toolbar={[
                  "undo",
                  "redo",
                  "|",
                  "heading",
                  "bold",
                  "italic",
                  "underline",
                  "strikethrough",
                  "blockQuote",
                  "|",
                  "fontSize",
                  "fontColor",
                  "fontBackgroundColor",
                  "|",
                  "alignment",
                  "subscript",
                  "superscript",
                  "|",
                  "bulletedList",
                  "numberedList",
                ]}
              />
            )}
          />
        </Show.When>
      </Grid2>
    </Grid2>
  );
};

export default PoliciesForm;
